import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Renders a DOM element (e.g. the letter preview) into an A4 PDF download.
export async function downloadElementPDF(element, filename = 'document.pdf') {
  if (!element) throw new Error('Nothing to export');
  const canvas = await html2canvas(element, { scale: 2, backgroundColor: '#ffffff', useCORS: true });
  const img = canvas.toDataURL('image/png');
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageW = 210; const pageH = 297; const margin = 10;
  const w = pageW - margin * 2;
  const h = (canvas.height * w) / canvas.width;
  if (h <= pageH - margin * 2) {
    doc.addImage(img, 'PNG', margin, margin, w, h);
  } else {
    // Split across pages
    let y = 0;
    const pageContentH = pageH - margin * 2;
    while (y < h) {
      if (y > 0) doc.addPage();
      doc.addImage(img, 'PNG', margin, margin - y, w, h);
      y += pageContentH;
    }
  }
  doc.save(filename);
}
